import { appConfig } from 'constants/appConfig';

export interface IAlphaHandoff {
  label: string;
  path?: string;
  url?: string;
}

const isPlainObject = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

const ownWebOrigin = (): string | undefined => {
  const base = (appConfig.webUrl ?? (appConfig.baseUrl ?? '').replace(/\/?api\/?$/i, '')).replace(/\/$/, '');
  if (!base) return undefined;
  try {
    return new URL(base, window.location.origin).origin;
  } catch {
    return undefined;
  }
};

export const isAllowedHandoffUrl = (url: string): boolean => {
  const allowedOrigin = ownWebOrigin();
  if (!allowedOrigin) return false;
  try {
    const parsed = new URL(url, allowedOrigin);
    return (parsed.protocol === 'http:' || parsed.protocol === 'https:') && parsed.origin === allowedOrigin;
  } catch {
    return false;
  }
};

const isValidRelativePath = (path: string): boolean => /^(#\/|\/)(?!\/)/.test(path);

export function parseHandoff(result: unknown): IAlphaHandoff | undefined {
  if (!isPlainObject(result) || !isPlainObject(result.handoff)) return undefined;
  const { path, url, label } = result.handoff;
  const hasPath = typeof path === 'string' && path.length > 0;
  const hasUrl = typeof url === 'string' && url.length > 0;
  if (!hasPath && !hasUrl) return undefined;
  return {
    path: hasPath ? (path as string) : undefined,
    url: hasUrl ? (url as string) : undefined,
    label: typeof label === 'string' && label ? label : 'Open in MSP Process',
  };
}

export function resolveHandoffHref(handoff: IAlphaHandoff): string | undefined {
  if (handoff.path && isValidRelativePath(handoff.path)) {
    const origin = ownWebOrigin();
    if (origin) return `${origin}${handoff.path}`;
  }
  if (handoff.url && isAllowedHandoffUrl(handoff.url)) {
    return handoff.url;
  }
  return undefined;
}
